export type ReportType = {
    id: string;
    label: string;
    description: string;
    href: string;
    defaultMetrics: string[];
    defaultDimensions: string[];
};

export const REPORT_TYPES: ReportType[] = [
    {
        id: 'chat_mensagem',
        label: 'Mensagens e Conversas',
        description:
            'Volume de chats, clientes, mensagens, notificações, sentimento do cliente e comportamento do atendente por período, canal ou equipe.',
        href: '/api/relatorios/chat_mensagem',
        defaultMetrics: ['qtd_chats', 'qtd_mensagens'],
        defaultDimensions: ['data_criacao_dia'],
    },
    {
        id: 'chat_resumo',
        label: 'Resumo de Chats com IA',
        description:
            'Análise de sentimento do cliente, comportamento do atendente, intenções identificadas e motivos avaliados pela IA.',
        href: '/api/relatorios/chat_resumo',
        defaultMetrics: ['total'],
        defaultDimensions: ['sentimento_cliente', 'comportamento_atendente'],
    },
    {
        id: 'chat_atendimento',
        label: 'Atendimento e Resolução',
        description:
            'Como os chats foram atendidos: bot, humano, transferências, redirecionamentos, resolução e opções sem resposta.',
        href: '/api/relatorios/chat_atendimento',
        defaultMetrics: ['qtd_total_chats', 'qtd_chats_resolvidos_bot', 'qtd_chats_transferidos_humanos'],
        defaultDimensions: ['data_criacao_dia'],
    },
    {
        id: 'sla',
        label: 'SLA — Tempo de Espera',
        description:
            'Tempo médio de espera do cliente até ser atendido por um humano, por período, canal ou equipe.',
        href: '/api/relatorios/sla',
        defaultMetrics: ['avg_sla_seconds'],
        defaultDimensions: ['data_criacao_dia', 'usuario_responsavel_nome'],
    },
    {
        id: 'chat_pontuacao',
        label: 'Pontuação de Atendimento (NPS)',
        description:
            'Pontuação média de satisfação (NPS) dada pelos clientes ao final do atendimento.',
        href: '/api/relatorios/chat_pontuacao',
        defaultMetrics: ['avg_score'],
        defaultDimensions: ['data_criacao_dia'],
    },
    {
        id: 'historico_chat_sessao',
        label: 'Histórico de Sessão (chat)',
        description:
            'Tempo total de permanência dos atendentes na tela de chat, por período e equipe.',
        href: '/api/relatorios/historico_chat_sessao',
        defaultMetrics: ['total_sessao_segundos'],
        defaultDimensions: ['data_criacao_dia'],
    },
    {
        id: 'historico_login',
        label: 'Histórico de Sessão',
        description:
            'Horários de login e logout dos atendentes, tempo total e médio de sessão, por período, atendente ou grupo.',
        href: '/api/relatorios/historico_login',
        defaultMetrics: ['total_sessoes', 'avg_sessao_segundos'],
        defaultDimensions: ['data_criacao_dia', 'usuario_nome'],
    },
];
